module.exports = __webpack_public_path__ + "img/dashboard-header-image.58cc51f1.png";